const SEO = [
  {
    page: "home",
    description: "함께 성장하는 개발자 윤해수입니다.",
    keywords: [
      "Harry",
      "Harry Yoon",
      "Haesoo",
      "Haesoo Yoon",
      "윤해수",
      "포트폴리오",
      "프론트엔드",
      "portfolio",
      "개발자",
      "developer",
      "frontend",
    ],
  },

  {
    page: "experience",
    description: "공유하는 개발 문화를 사랑합니다.",
    keywords: [
      "Harry",
      "Harry Yoon",
      "Haesoo",
      "Haesoo Yoon",
      "윤해수",
      "포트폴리오",
      "프론트엔드",
      "portfolio",
      "개발자",
      "developer",
      "frontend",
    ],
  },

  {
    page: "projects",
    description:
      "더 나은 사용자 경험과 효율적인 아키텍처를 고민하는 개발자가 되고자 합니다.",
    keywords: [
      "Harry",
      "Harry Yoon",
      "Haesoo",
      "Haesoo Yoon",
      "윤해수",
      "포트폴리오",
      "프론트엔드",
      "portfolio",
      "개발자",
      "developer",
      "frontend",
    ],
  },

  {
    page: "contact",
    description: "커피챗은 언제든 환영입니다. 연락을 기다리겠습니다.",
    keywords: [
      "Harry",
      "Harry Yoon",
      "Haesoo",
      "Haesoo Yoon",
      "윤해수",
      "포트폴리오",
      "프론트엔드",
      "portfolio",
      "개발자",
      "developer",
      "frontend",
    ],
  },
];

export default SEO;
